import React from 'react';
import styles from '../CaseIntelligenceVibrantPage.module.scss';

const LoadingSkeleton: React.FC = () => {
  return (
    <div className={styles.loadingShell}>
      <div className={styles.loadingHero}>
        <div className={styles.loadingRing} />
        <div className={styles.loadingSummaryCard}>
          <div className={styles.skeletonLine} />
          <div className={styles.skeletonLine} />
          <div className={styles.skeletonLine} />
          <div className={styles.skeletonChipRow}>
            <div className={styles.skeletonChip} />
            <div className={styles.skeletonChip} />
            <div className={styles.skeletonChip} />
          </div>
        </div>
      </div>
      <div className={styles.loadingCards}>
        <div className={styles.loadingPanel} />
        <div className={styles.loadingPanel} />
      </div>
      <div className={styles.loadingTabs}>
        <div className={styles.skeletonTab} />
        <div className={styles.skeletonTab} />
        <div className={styles.skeletonTab} />
        <div className={styles.skeletonTab} />
      </div>
      <div className={styles.loadingBody} />
    </div>
  );
};

export default LoadingSkeleton;
